import ChatList from './Sidebars/ChatList';
import Chat from './Chat/Chat';
import {useState} from '../app3';

export default function Messenger() {
  const [state, patch] = useState({
    currentChatId: 777000,
  });

  function handleClickChat(e, chatId) {
    patch({
      currentChatId: chatId,
    });
  }

  return h => {
    return h('div', 'app-container', [
      h('div', 'left-container', [
        h('div', 'left-container__top', [
          h('button'),
          h('div', 'search-panel')
        ]),
        h('div', 'left-container__content', [
          h(ChatList, {
            key: 'chat-list',
            props: {
              handleClickChat
            }
          })
        ])
      ]),
      h(Chat, {
        key: 'chat-container',
        props: {
          currentChatId: state.currentChatId
        }
      })
    ])
  }
}
